import React from 'react';
import WithSection from '../../components/WithSection/WithSection';
import { graphql } from 'gatsby';
import Box from '../../components/Box/Box';
import Button from '../../components/Button/Button';
import { rem } from 'polished';

const BackToSection = ({ data }) => {
    const {
        primary: { cta_text, section_id },
    } = data;

    return (
        <Box gridColumn="1/-1">
            <Box
                padding={rem(20)}
                maxWidth={rem(466)}
                boxShadow="primary-thin"
                marginX="auto"
                borderRadius="sm"
            >
                <Box py={rem(8)}>
                    <Box as="a" href={`#${section_id}`} width="100%">
                        <Button size="lg" fullWidth>
                            {cta_text}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default WithSection(BackToSection);

export const _ = graphql`
    fragment BACK_TO_SECTION on PrismicSectionDataBodyBackToSection {
        id
        primary {
            cta_text
            section_id
        }
    }
`;
